import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "trophy"
}

import IconComponent from '@/components/IconComponent.vue';
import IconTrophy from '@/assets/VueIcons/IconTrophy.vue';
import IconAward from '@/assets/VueIcons/IconAward.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'TrophyCol',
  props: {
  placement: Number
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.placement <= 3)
    ? (_openBlock(), _createBlock(IconComponent, {
        key: 0,
        class: "trophy"
      }, {
        default: _withCtx(() => [
          (__props.placement === 1)
            ? (_openBlock(), _createBlock(IconTrophy, { key: 0 }))
            : (_openBlock(), _createBlock(IconAward, { key: 1 }))
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("span", _hoisted_1))
}
}

})